import { render, staticRenderFns } from "./TwoTabsPage.vue?vue&type=template&id=e733c1ec&scoped=true&"
import script from "./TwoTabsPage.vue?vue&type=script&lang=js&"
export * from "./TwoTabsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e733c1ec",
  null
  
)

export default component.exports